export const orderConstants = {
  ADD_ORDER_REQUEST: "ADD_ORDER_REQUEST",
  ADD_ORDER_SUCCESS: "ADD_ORDER_SUCCESS",
  ADD_ORDER_FAILURE: "ADD_ORDER_FAILURE",

  GET_ORDERS_REQUEST: "GET_ORDERS_REQUEST",
  GET_ORDERS_SUCCESS: "GET_ORDERS_SUCCESS",
  GET_ORDERS_FAILURE: "GET_ORDERS_FAILURE",
  GET_ORDERS_CLEAR: "GET_ORDERS_CLEAR",

  EDIT_ORDER_STATUS_REQUEST: "EDIT_ORDER_STATUS_REQUEST",
  EDIT_ORDER_STATUS_SUCCESS: "EDIT_ORDER_STATUS_SUCCESS",
  EDIT_ORDER_STATUS_FAILURE: "EDIT_ORDER_STATUS_FAILURE",

  EDIT_ORDER_QUANTITY_REQUEST: "EDIT_ORDER_QUANTITY_REQUEST",
  EDIT_ORDER_QUANTITY_SUCCESS: "EDIT_ORDER_QUANTITY_SUCCESS",
  EDIT_ORDER_QUANTITY_FAILURE: "EDIT_ORDER_QUANTITY_FAILURE",

  EDIT_PRODUCT_ORDER_REQUEST: "EDIT_PRODUCT_ORDER_REQUEST",
  EDIT_PRODUCT_ORDER_SUCCESS: "EDIT_PRODUCT_ORDER_SUCCESS",
  EDIT_PRODUCT_ORDER_FAILURE: "EDIT_PRODUCT_ORDER_FAILURE",

  EDIT_ORDER_PRICE_REQUEST: "EDIT_ORDER_PRICE_REQUEST",
  EDIT_ORDER_PRICE_SUCCESS: "EDIT_ORDER_PRICE_SUCCESS",
  EDIT_ORDER_PRICE_FAILURE: "EDIT_ORDER_PRICE_FAILURE",

  CANCEL_PRODUCT_ORDER_REQUEST: "CANCEL_PRODUCT_ORDER_REQUEST",
  CANCEL_PRODUCT_ORDER_SUCCESS: "CANCEL_PRODUCT_ORDER_SUCCESS",
  CANCEL_PRODUCT_ORDER_FAILURE: "CANCEL_PRODUCT_ORDER_FAILURE",

  GET_SETTING_SMS_REQUEST: "GET_SETTING_SMS_REQUEST",
  GET_SETTING_SMS_SUCCESS: "GET_SETTING_SMS_SUCCESS",
  GET_SETTING_SMS_FAILURE: "GET_SETTING_SMS_FAILURE",

  EDIT_SETTING_SMS_REQUEST: "EDIT_SETTING_SMS_REQUEST",
  EDIT_SETTING_SMS_SUCCESS: "EDIT_SETTING_SMS_SUCCESS",
  EDIT_SETTING_SMS_FAILURE: "EDIT_SETTING_SMS_FAILURE",

  EDIT_SETTING_SMS: "EDIT_SETTING_SMS",

  ADD_ORDER_FILTER: "ADD_ORDER_FILTER",

  SEND_ORDER_SMS_REQUEST: "SEND_ORDER_SMS_REQUEST",
  SEND_ORDER_SMS_SUCCESS: "SEND_ORDER_SMS_SUCCESS",
  SEND_ORDER_SMS_FAILURE: "SEND_ORDER_SMS_FAILURE",

  GET_ORDER_SHARE_LINK_REQUEST: "GET_ORDER_SHARE_LINK_REQUEST",
  GET_ORDER_SHARE_LINK_SUCCESS: "GET_ORDER_SHARE_LINK_SUCCESS",
  GET_ORDER_SHARE_LINK_FAILURE: "GET_ORDER_SHARE_LINK_FAILURE",

  GET_ORDER_DETAILS_REQUEST: "GET_ORDER_DETAILS_REQUEST",
  GET_ORDER_DETAILS_SUCCESS: "GET_ORDER_DETAILS_SUCCESS",
  GET_ORDER_DETAILS_FAILURE: "GET_ORDER_DETAILS_FAILURE",

  CONFIRM_FINANCIAL_ORDER_REQUEST: "CONFIRM_FINANCIAL_ORDER_REQUEST",
  CONFIRM_FINANCIAL_ORDER_SUCCESS: "CONFIRM_FINANCIAL_ORDER_SUCCESS",
  CONFIRM_FINANCIAL_ORDER_FAILURE: "CONFIRM_FINANCIAL_ORDER_FAILURE",

  UPLOAD_DOC_REQUEST: "UPLOAD_DOC_REQUEST",
  UPLOAD_DOC_SUCCESS: "UPLOAD_DOC_SUCCESS",
  UPLOAD_DOC_FAILURE: "UPLOAD_DOC_FAILURE",

  SHOW_DOC_REQUEST: "SHOW_DOC_REQUEST",
  SHOW_DOC_SUCCESS: "SHOW_DOC_SUCCESS",
  SHOW_DOC_FAILURE: "SHOW_DOC_FAILURE",

  EDIT_SALE_OPPORTUNITY_SELLER_REQUEST: "EDIT_SALE_OPPORTUNITY_SELLER_REQUEST",
  EDIT_SALE_OPPORTUNITY_SELLER_SUCCESS: "EDIT_SALE_OPPORTUNITY_SELLER_SUCCESS",
  EDIT_SALE_OPPORTUNITY_SELLER_FAILURE: "EDIT_SALE_OPPORTUNITY_SELLER_FAILURE",

  GET_SUPPORT_ORDER_REQUEST: "GET_SUPPORT_ORDER_REQUEST",
  GET_SUPPORT_ORDER_SUCCESS: "GET_SUPPORT_ORDER_SUCCESS",
  GET_SUPPORT_ORDER_FAILURE: "GET_SUPPORT_ORDER_FAILURE",

  ADD_ORDER_TRACKING_CODE_REQUEST: "ADD_ORDER_TRACKING_CODE_REQUEST",
  ADD_ORDER_TRACKING_CODE_SUCCESS: "ADD_ORDER_TRACKING_CODE_SUCCESS",
  ADD_ORDER_TRACKING_CODE_FAILURE: "ADD_ORDER_TRACKING_CODE_FAILURE",
  ADD_ORDER_TRACKING_CODE_CLEAR: "ADD_ORDER_TRACKING_CODE_CLEAR",

  CLEAR_SUPPORT_ORDER: "CLEAR_SUPPORT_ORDER",

  FAIL_SALE_OPPORTUNITY_REQUEST: "FAIL_SALE_OPPORTUNITY_REQUEST",
  FAIL_SALE_OPPORTUNITY_SUCCESS: "FAIL_SALE_OPPORTUNITY_SUCCESS",
  FAIL_SALE_OPPORTUNITY_FAILURE: "FAIL_SALE_OPPORTUNITY_FAILURE",

  GET_FAIL_REASONS_REQUEST: "GET_FAIL_REASONS_REQUEST",
  GET_FAIL_REASONS_SUCCESS: "GET_FAIL_REASONS_SUCCESS",
  GET_FAIL_REASONS_FAILURE: "GET_FAIL_REASONS_FAILURE",

  EDIT_PRIORITY_REQUEST: "EDIT_PRIORITY_REQUEST",
  EDIT_PRIORITY_SUCCESS: "EDIT_PRIORITY_SUCCESS",
  EDIT_PRIORITY_FAILURE: "EDIT_PRIORITY_FAILURE",

  EDIT_TRACKING_TIME_REQUEST: "EDIT_TRACKING_TIME_REQUEST",
  EDIT_TRACKING_TIME_SUCCESS: "EDIT_TRACKING_TIME_SUCCESS",
  EDIT_TRACKING_TIME_FAILURE: "EDIT_TRACKING_TIME_FAILURE",
  EDIT_TRACKING_TIME_CLEAR: "EDIT_TRACKING_TIME_ClEAR",

  GET_PAYMENT_LINK_REQUEST: "GET_PAYMENT_LINK_REQUEST",
  GET_PAYMENT_LINK_SUCCESS: "GET_PAYMENT_LINK_SUCCESS",
  GET_PAYMENT_LINK_FAILURE: "GET_PAYMENT_LINK_FAILURE",
  GET_PAYMENT_LINK_CLEAR: "GET_PAYMENT_LINK_ClEAR",

  TOTAL_PAID_REQUEST: "TOTAL_PAID_REQUEST",
  TOTAL_PAID_SUCCESS: "TOTAL_PAID_SUCCESS",
  TOTAL_PAID_FAILURE: "TOTAL_PAID_FAILURE",
  TOTAL_PAID_CLEAR: "TOTAL_PAID_ClEAR",
};
